module.exports = "<!-- * PRESS-RELEASE * -->\n<ddw-pages-navbar></ddw-pages-navbar>\n<router-outlet></router-outlet>\n"